import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import HandwrittenText from "../../../components/shared/HandwrittenText";
import { MOTION_DURATION, MOTION_EASE } from "../../../shared/constants/motion";

const headlineContainer = { hidden: {}, show: { transition: { staggerChildren: 0.1, delayChildren: 0.15 } } };
const wordItem = { hidden: { opacity: 0, y: 22 }, show: { opacity: 1, y: 0, transition: { duration: MOTION_DURATION.reveal, ease: MOTION_EASE.editorial } } };
const words = values => values.map((word, index) => <React.Fragment key={word}><motion.span variants={wordItem} className="inline-block">{word}</motion.span>{index < values.length - 1 ? " " : null}</React.Fragment>);

export default function FlowHeadline() {
  const reduceMotion = useReducedMotion();
  return <>
    <motion.h1 id="page-title" aria-label="Find out where you actually stand." variants={headlineContainer} initial={reduceMotion ? false : "hidden"} animate="show" className="hero-headline font-black text-black"><span className="block">{words(["Find", "out", "where"])}</span><span className="block">{words(["you", "actually"])}</span></motion.h1>
    <HandwrittenText id="vara-stand" text="stand." color="#ef4444" strokeWidth={1.3} textAlign="left" duration={reduceMotion ? 0 : 1200} delay={reduceMotion ? 0 : 500} className="hero-stand" />
  </>;
}
